import { get, put } from '@/api';

import { CompanySettingListItem } from '@/types/company-settings';

export type CompanySettingJobStatusProperties = {
  progress: string;
  edit_side: string;
};

export type CompanySettingValue =
  | string
  | number
  | boolean
  | null
  | number[]
  | CompanySettingListItem[]
  | CompanySettingJobStatusProperties;

export type CompanySetting = {
  key: string;
  value: CompanySettingValue;
};

export type CompanySettingsUpdateParams = CompanySetting[];

export const getCompanySettings = async params => {
  const { id } = params;

  return (await get<CompanySetting[]>(`/organizations/${id}/settings`)).data;
};

export const updateCompanySettings = async (id: string, params: CompanySettingsUpdateParams) => {
  const response = await put<CompanySetting[]>(`/organizations/${id}/settings`, params);

  return response.data;
};
